// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.top-gainers-page {
  padding: 2rem;
  max-width: 1400px;
  margin: 0 auto;
}

.top-gainers-header {
  margin-bottom: 2rem;
}

.top-gainers-title {
  font-size: 2rem;
  font-weight: bold;
  color: #333;
  margin: 0 0 0.5rem 0;
}

.top-gainers-subtitle {
  color: #666;
  margin: 0;
}

.top-gainers-filters {
  margin-bottom: 1.5rem;
  padding: 1rem;
  background: #f5f5f5;
  border-radius: 8px;
}

.filter-group {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.filter-group label {
  font-weight: 500;
  color: #333;
}

.filter-select {
  padding: 0.5rem 1rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
  background: white;
  cursor: pointer;
}

.filter-select:hover {
  border-color: #999;
}

.filter-select:focus {
  outline: none;
  border-color: #4CAF50;
  box-shadow: 0 0 0 2px rgba(76, 175, 80, 0.2);
}

.error-message {
  padding: 1rem;
  background: #fee;
  color: #c33;
  border-radius: 4px;
  margin-bottom: 1rem;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem;
  gap: 1rem;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #4CAF50;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.top-gainers-stats {
  margin-bottom: 1rem;
  padding: 0.75rem;
  background: #e8f5e9;
  border-radius: 4px;
  color: #2e7d32;
}

.empty-message {
  text-align: center;
  padding: 3rem;
  color: #999;
}

.top-gainers-table-container {
  overflow-x: auto;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.top-gainers-table {
  width: 100%;
  border-collapse: collapse;
  background: white;
}

.top-gainers-table thead {
  background: #4CAF50;
  color: white;
}

.top-gainers-table th {
  padding: 1rem;
  text-align: left;
  font-weight: 600;
  border-bottom: 2px solid #45a049;
}

.top-gainers-table tbody tr {
  border-bottom: 1px solid #eee;
}

.top-gainers-table tbody tr:hover {
  background: #f9f9f9;
}

.top-gainers-table td {
  padding: 0.75rem 1rem;
}

.rank-cell {
  font-weight: bold;
  color: #666;
  text-align: center;
  width: 60px;
}

.price-cell {
  font-family: 'Courier New', monospace;
  text-align: right;
}

.percent-cell {
  font-weight: bold;
  text-align: right;
  font-size: 1.1rem;
}

.percent-cell.positive {
  color: #2e7d32;
}

.percent-cell.negative {
  color: #c62828;
}

@media (max-width: 768px) {
  .top-gainers-page {
    padding: 1rem;
  }

  .top-gainers-table-container {
    font-size: 0.9rem;
  }

  .top-gainers-table th,
  .top-gainers-table td {
    padding: 0.5rem;
  }
}




`, "",{"version":3,"sources":["webpack://./src/pages/TopGainers.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,eAAe;EACjB;AACF","sourcesContent":[".top-gainers-page {\n  padding: 2rem;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.top-gainers-header {\n  margin-bottom: 2rem;\n}\n\n.top-gainers-title {\n  font-size: 2rem;\n  font-weight: bold;\n  color: #333;\n  margin: 0 0 0.5rem 0;\n}\n\n.top-gainers-subtitle {\n  color: #666;\n  margin: 0;\n}\n\n.top-gainers-filters {\n  margin-bottom: 1.5rem;\n  padding: 1rem;\n  background: #f5f5f5;\n  border-radius: 8px;\n}\n\n.filter-group {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.filter-group label {\n  font-weight: 500;\n  color: #333;\n}\n\n.filter-select {\n  padding: 0.5rem 1rem;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 1rem;\n  background: white;\n  cursor: pointer;\n}\n\n.filter-select:hover {\n  border-color: #999;\n}\n\n.filter-select:focus {\n  outline: none;\n  border-color: #4CAF50;\n  box-shadow: 0 0 0 2px rgba(76, 175, 80, 0.2);\n}\n\n.error-message {\n  padding: 1rem;\n  background: #fee;\n  color: #c33;\n  border-radius: 4px;\n  margin-bottom: 1rem;\n}\n\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 3rem;\n  gap: 1rem;\n}\n\n.loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #f3f3f3;\n  border-top: 4px solid #4CAF50;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.top-gainers-stats {\n  margin-bottom: 1rem;\n  padding: 0.75rem;\n  background: #e8f5e9;\n  border-radius: 4px;\n  color: #2e7d32;\n}\n\n.empty-message {\n  text-align: center;\n  padding: 3rem;\n  color: #999;\n}\n\n.top-gainers-table-container {\n  overflow-x: auto;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.top-gainers-table {\n  width: 100%;\n  border-collapse: collapse;\n  background: white;\n}\n\n.top-gainers-table thead {\n  background: #4CAF50;\n  color: white;\n}\n\n.top-gainers-table th {\n  padding: 1rem;\n  text-align: left;\n  font-weight: 600;\n  border-bottom: 2px solid #45a049;\n}\n\n.top-gainers-table tbody tr {\n  border-bottom: 1px solid #eee;\n}\n\n.top-gainers-table tbody tr:hover {\n  background: #f9f9f9;\n}\n\n.top-gainers-table td {\n  padding: 0.75rem 1rem;\n}\n\n.rank-cell {\n  font-weight: bold;\n  color: #666;\n  text-align: center;\n  width: 60px;\n}\n\n.price-cell {\n  font-family: 'Courier New', monospace;\n  text-align: right;\n}\n\n.percent-cell {\n  font-weight: bold;\n  text-align: right;\n  font-size: 1.1rem;\n}\n\n.percent-cell.positive {\n  color: #2e7d32;\n}\n\n.percent-cell.negative {\n  color: #c62828;\n}\n\n@media (max-width: 768px) {\n  .top-gainers-page {\n    padding: 1rem;\n  }\n\n  .top-gainers-table-container {\n    font-size: 0.9rem;\n  }\n\n  .top-gainers-table th,\n  .top-gainers-table td {\n    padding: 0.5rem;\n  }\n}\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
